import { useTranslation } from 'react-i18next';

import MainLayout from '@/features/common/components/MainLayout';

const animatedLogo = '/ciblijob-animated.svg';

export function MaintenanceScreen() {
  const { t } = useTranslation();

  return (
    <MainLayout className="gap-8 md:gap-12 text-center">
      <img
        src={animatedLogo}
        alt="CibliJob"
        className="w-[280px] md:w-[400px] lg:w-[500px] h-auto"
      />
      <div className="flex flex-col gap-4 max-w-lg">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-balance text-foreground">
          {t('MaintenanceScreen.title', 'Service temporairement indisponible')}
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-balance text-muted-foreground">
          {t(
            'MaintenanceScreen.message',
            'Nous effectuons une maintenance. Veuillez réessayer ultérieurement.',
          )}
        </p>
      </div>
      <div className="mt-4 inline-flex items-center gap-2.5 rounded-full border border-primary/30 bg-primary/10 px-6 py-3 text-base font-medium text-primary-dark">
        <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-primary" />
        {t('MaintenanceScreen.inProgress', 'Maintenance en cours')}
      </div>
    </MainLayout>
  );
}
